<template>
  <div class="forgot-password section fullscreen-content">
    <div class="container">
      <div class="auth-form zoomIn">
        <form-heading></form-heading>
        <div class="form-field">
          <input
            type="text"
            v-validate="'required|email'"
            name="email"
            v-model="email"
            :placeholder="$t('auth.enter_your_email')"
          />
          <span>{{ errors.first('email') }}</span>
        </div>
        <div class="form-field">
          <button
            class="button shadow"
            :disabled="loading"
            :class="{ loading: loading }"
            @click="submit()"
          >{{$t('auth.send')}}</button>
          <span v-if="message != ''" class="form-response" :class="responseType">{{message}}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Api from '@/services/api-service'
import FormHeading from '@/components/shop/auth/AuthFormHeading'
export default {
  name: 'forgot-password',
  components: {
    FormHeading
  },
  data () {
    return {
      email: '',
      activeForm: 'sign-in',
      message: '',
      responseType: '',
      loading: false
    }
  },
  methods: {
    resetResponse () {
      this.message = '';
      this.responseType = '';
    },
    setResponse (type, message) {
      this.message = message
      this.responseType = type
    },
    submit () {
      if (!this.loading) {
        this.$validator.validateAll().then(result => {
          if (result) {
            this.message = '';
            this.responseType = '';
            this.loading = true
            Api.post('/password/email', { email: this.email })
              .then(response => {
                this.message = 'Reset link successfully sent.';
                this.responseType = response.data.status
                if (response.data.status == 'success') {
                  this.email = '';
                }
                this.loading = false
              })
              .catch(error => {
                this.responseType = 'error';
                this.loading = false
                if (error.response.status == 419) {
                  this.message = 'Please wait. Page reloading.';
                  window.location.href = '/sign-in';
                } else {
                  this.setResponse('error', 'please_check_the_fields')
                  for (var key in error.response.data) {
                    this.errors.add({
                      field: key,
                      msg: error.response.data[key]
                    })
                    this.$validator.flag(key, {
                      invalid: true
                    })
                  }
                }
              })
          } else {
            this.setResponse('error', 'please_check_the_fields')
          }
        })
      }
    }
  },
  created () {
    if (this.$store.state.is_auth) {
      this.$router.push('/')
    }
  }
}
</script>

<style lang="scss">
.forgot-password {
  padding-top: 130px;
}
</style>
